import cn from 'classnames'
import { useCallback } from 'react'
import styles from '../../Tabs.module.scss'

interface TabProps<TValue> {
  name: string
  value: TValue
  onSelect: (value: TValue) => void
  selected: boolean
}

export const Tab = <TValue,>({
  name,
  value,
  onSelect = () => {},
  selected = false,
}: TabProps<TValue>) => {
  const select = useCallback(() => {
    onSelect(value)
  }, [onSelect, value])

  return (
    <button
      type="button"
      className={cn(styles.tab, {
        [styles.isActive]: selected,
      })}
      onClick={select}
    >
      {name}
    </button>
  )
}
